// ---------------------------------------------------------------------------
// Design tokens (mirror charts-1_3.txt CSS variables)
// ---------------------------------------------------------------------------
const T = {
  bg:            'transparent',
  card:          'var(--a13-card)',
  sidebar:       'var(--a13-sidebar)',
  border:        'var(--border-color)',
  text:          'var(--text-color)',
  textSecondary: 'var(--text-secondary-color)',
  primary:       '#f97316',
  accent:        '#2dd4bf',
  success:       '#22c55e',
  warning:       '#eab308',
  error:         '#ef4444',
  // Elevation surfaces — automatically flip between dark/light via CSS vars
  surface:       'var(--a13-surface)',
  surface2:      'var(--a13-surface-2)',
  surface3:      'var(--a13-surface-3)',
  hover:         'var(--hover-color)',
};

export default T;
